import { render, staticRenderFns } from "./document-preview-picture.vue?vue&type=template&id=a5419d48&scoped=true&"
import script from "./document-preview-picture.vue?vue&type=script&lang=js&"
export * from "./document-preview-picture.vue?vue&type=script&lang=js&"
import style0 from "./document-preview-picture.vue?vue&type=style&index=0&id=a5419d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5419d48",
  null
  
)

export default component.exports